'use client';

export { VideoRecommendationsComponent as VideoRecommendationsComponentB } from './VideoRecommendationsComponent';
